export class UnauthorizedApiError extends Error {
  constructor(message: string = 'Unauthorized') {
    super(message);
    this.name = 'UnauthorizedApiError';
    Object.setPrototypeOf(this, UnauthorizedApiError.prototype);
  }
}
